class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('#shopify-section-header');
    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // extra events
      this.shadow?.addEventListener('click', this.closeAll.bind(this));
    }

    // Animate inactive menu items out
    this.headerTimeout = null;
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.headerTimeout);
      this.headerTimeout = setTimeout(() => {
        document.querySelector('body').classList.add('header-is-hovered');
      }, this.options.hoverDelay);
    });
    this.addEventListener('mouseleave', () => {
      clearTimeout(this.headerTimeout);
      this.headerTimeout = setTimeout(() => {
        document.querySelector('body').classList.remove('header-is-hovered');
      }, this.options.hoverDelay);
    });
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    if (this.headerWrapper) {
      this.headerWrapper.classList.add('shopify-section-header--open');
    }
    this.toggleHeaderClass(true);
  }

  close(group) {
    super.close(group);
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove('shopify-section-header--open');
    }
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
    if (this.headerWrapper) {
      this.headerWrapper.classList.add('shopify-section-header--open');
    }
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove('shopify-section-header--open');
    }
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      document.body.classList.add('header-is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        document.body.classList.remove('header-is-open');
        this.inverse && this.header.classList.remove('header--inverse-solid');
      }
    }
  }
}

class ToggleMobileNavigation extends ToggleElementClass {

  constructor() {
    super();

    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('#shopify-section-header');

    if (this.header) {
      this.shadow = this.header.querySelector('.header-shadow');
      this.inverse = !!this.header.classList.contains('header--inverse');

      // Extra events
      document.addEventListener('keyup', (event) => {
        this.onKeyUp(event);
      });

      this.shadow?.addEventListener('click', (event) => {
        this.remove(event);
      });
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header-is-open')) {
      return;
    }
    if(event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    trapFocus(this.header);
  }

  remove() {
    super.remove();
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}


class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest('[data-header]');

    // options
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener('keyup', (event) => {
      this.onKeyUp(event);
    });

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener('click', () => {
      document.body.classList.remove('header-is-open');
      document.body.classList.remove('menu-drawer-is-open');
      // Focus on input element if provided
      if(this.options.focusTarget) {
        document.querySelector(this.options.focusTarget)?.focus();
      }
    });

  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header-search-is-open')) {
      return;
    }
    if(event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add('header-search-is-open');
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      document.body.classList.remove('header-search-is-open');
    }
    removeTrapFocus();
  }

}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}
